module.exports = __webpack_public_path__ + "assets/img/gar8-12.c22a782d.jpg";